(function () {
    'use strict';

    angular
        .module('salesflare.components.tasks.today', [])
        .component('sfTasksToday', {
            controller,
            controllerAs: 'vm',
            templateUrl: 'app-ajs/components/tasks/today/today.html',
            bindings: {
                entityCountString: '<', // The amount of tasks in the db
                tasks: '<', // The md-virtual repeat object
                loadingTasks: '<',
                onAddTask: '&',
                onDismissTask: '&',
                onSelectedChanged: '&', // Directly bound to the task event
                onEditTask: '&',
                onEditedTask: '&',
                onUpdateTask: '&',
                isTaskFilterApplied: '&',
                usedBadFilter: '<',
                badFilterError: '<',
                setFilters: '&',
                getSearch: '&'
            }
        });


    function controller($timeout, $state, $scope, $mdMedia, flagsService, model, $translate, $sce, $sanitize) {

        const vm = this;
        let tasksTour;
        let walkThroughTimeout;
        vm.me = model.me;
        vm.$mdMedia = $mdMedia;

        vm.$onInit = function () {

            if (flagsService.get('showTaskWalkthrough') === true) {
                showWalkThrough();
            }

            vm.doneQuote = getRandomDoneQuote();
            vm.noTasksFoundText = $translate.instant('No tasks found');
            vm.recentlyCompletedTasks = [];

            // Ideally this would be dynamic but virtual repeat only allows setting it on load basically
            vm.itemSize = $mdMedia('gt-sm') ? 48 : 72;

            const linkText = $translate.instant('this filter');
            const translatedPhrase = $translate.instant('No tasks match {{linkText}}', { linkText });
            // Replace the placeholder with the actual link HTML (ng-click won't work in ng-bind-html, so we use event delegation)
            vm.noTasksMatchHtml = $sce.trustAsHtml(translatedPhrase.replace(linkText, '<a class="click">' + linkText + '</a>'));
        };


        vm.$onDestroy = function () {

            if (tasksTour) {
                tasksTour.cancel();
            }

            if (walkThroughTimeout) {
                $timeout.cancel(walkThroughTimeout);
            }
        };

        vm.onAddTaskProxy = function ($event) {

            return vm.onAddTask({
                $event
            });
        };

        vm.onDismissTaskProxy = function ($event) {

            vm.recentlyCompletedTasks = vm.recentlyCompletedTasks.filter(function (t) {

                return t.id !== $event.task.id;
            });

            return vm.onDismissTask({
                $event
            });
        };

        vm.onEditTaskProxy = function ($event) {

            return vm.onEditTask({
                $event
            });
        };

        vm.onEditedTaskProxy = function ($event) {

            return vm.onEditedTask({
                $event
            });
        };

        vm.onUpdateTaskProxy = function ($event) {

            // If completed move to completed list otherwise remove from that list
            if ($event.task.completed === true) {
                vm.recentlyCompletedTasks.push($event.task);
            }
            else if (!$event.task.completed) {
                vm.recentlyCompletedTasks = vm.recentlyCompletedTasks.filter(function (t) {

                    return t.id !== $event.task.id;
                });
            }

            return vm.onUpdateTask({
                $event
            });
        };

        vm.go = function (target) {

            return $state.go(target);
        };

        function showWalkThrough() {

            walkThroughTimeout = $timeout(function () {

                tasksTour = new Shepherd.Tour({
                    defaultStepOptions: {
                        popperOptions: {
                            // Adds an offset of 12px to the tooltip so the arrow (instead of the content) starts on the target element
                            modifiers: [{ name: 'offset', options: { offset: [0, 12] } }]
                        }
                    }
                });

                const text = $translate.instant('Type here to add new tasks. &#x261D \n\n Salesflare will also create tasks automatically. It will remind you to respond to emails, add meeting notes, add customers, and more. These tasks also automatically get marked as completed when you complete them. You can always change this in the Settings.');

                tasksTour.addStep({
                    id: 'explain-tasks',
                    title: $translate.instant('Welcome to your to do list!'),
                    text,
                    attachTo: {
                        element: '.taskCreate',
                        on: 'bottom'
                    },
                    buttons: [{
                        text: $translate.instant('GOT IT!'),
                        action: tasksTour.next
                    }]
                });

                tasksTour.on('complete', function () {

                    return flagsService.set('showTaskWalkthrough', false);
                });

                return tasksTour.start();
            }, 1000);
        }

        function getRandomDoneQuote() {

            const doneQuotes = [
                $translate.instant('All done! You\'re amazing.') + ' <span class="sf-emoji">\u2728</span>', // ✨
                $translate.instant('You\'re simply the best.'),
                $translate.instant('Hell yeah!') + ' <span class="sf-emoji">\uD83D\uDCAA</span>',  // 💪
                $translate.instant('Done, done aaaand done.')
            ];
            return doneQuotes[Math.floor(Math.random() * doneQuotes.length)];
        }

        vm.handleNoTasksMatchClick = function ($event) {

            if ($event.target.classList.contains('click')) {
                return vm.setFilters($event);
            }
        };

        /**
         * Returns sanitized and trusted HTML for "Please update the filters to continue." with link.
         *
         * @returns {Object} Trusted HTML for ng-bind-html
         */
        vm.getPleaseUpdateFiltersHtml = function () {
            const raw = $translate.instant('Please update <a href="">the filters</a> to continue.');
            return $sce.trustAsHtml($sanitize(raw));
        };

        vm.handlePleaseUpdateFiltersClick = function ($event) {
            if ($event.target.tagName === 'A') {
                $event.preventDefault();
                vm.setFilters($event);
            }
        };
    }
})();
